/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { default as BaseChannelRoute } from 'embercom/routes/apps/app/standalone/channels/base-channels';
import type Transition from '@ember/routing/transition';
import { taskFor } from 'ember-concurrency-ts';

export default class FinStandaloneSalesforceCasesRoute extends BaseChannelRoute {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;

  get salesforcePlatform() {
    return this.finStandaloneService.salesforcePlatform;
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    if (this.salesforcePlatform.salesforceDataLoader.isLoadingSalesforceSetupData) {
      await taskFor(this.salesforcePlatform.salesforceDataLoader.loadSalesforceSetupData).last!;
    }
  }
}
